import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Radio,
	RadioGroup,
	FormControlLabel,
	FormHelperText,
	LinearProgress,
	Typography
} from '@material-ui/core';

import AuthorizedUser from "../utils/AuthorizedUser";
import CheckedRadioIcon from "../assets/checked-radio.svg";
import UncheckedRadioIcon from "../assets/unchecked-radio.svg";

const styles = makeStyles(theme => ({
	bottomHelperText: {
		display: "block",
		fontSize: "0.985rem",
		marginBottom: theme.spacing(2)
	},

	progress: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(7)
	},

	show: {
		display: "block"
	},

	moreContrastRadio: {
		'&$checked': {
			// color: theme.palette.secondary.purple
		}
	},
	checked: {},
	description: {
		color: theme.palette.secondary.grey
	},
	label: {
		marginRight: 40
	},
	radioGroup: {
		marginTop: 16,
		marginBottom: 16
	},
	radioRoot: {
		marginRight: 3,
		"&.MuiIconButton-root": {
			width: 'auto',
			height: 'auto'
		}
	},
	title: {
		fontWeight: 600
	}
}));


function LabeledRadioGroup(props) {
	const [selected, setSelected] = useState(props.value);

	useEffect(() => {
		setSelected(props.value);
	}, [props.value]);

	const handleChange = (event) => {
		setSelected(event.target.value );
	};

	let classes = styles(),
		moreContrast = AuthorizedUser.wantsMoreContrast(),
		{name, isLoading, disabled, topHelperText, bottomHelperText, buttonColor, buttons, onChange, ...rest} = props;

	return (
		<div>
			{topHelperText ? (
				<FormHelperText
					disabled={disabled}
					className={classes.show}>{topHelperText}</FormHelperText>
			) : null}
			{(!isLoading) ? (
				<div>
					<RadioGroup
						{...rest}
						name={name}
						className={classes.radioGroup}
						value={selected}
						onChange={(e, v) => {e.target.value = v; handleChange(e); onChange(e);}}>
						{buttons.map((button, i) =>
							<FormControlLabel
								key={i}
								disabled={disabled}
								value={button.name}
								className={classes.label}
								control={
									<Radio
										key={button.id}
										color={buttonColor || 'secondary'}
										inputProps={{
											'aria-label': rest.label || '',
											'aria-describedby': `${rest.id}-helper-text`}}
										classes={{
											root: classes.radioRoot
										}}
										icon={<img src={UncheckedRadioIcon} alt="unchecked icon" />}
										checkedIcon={<img src={CheckedRadioIcon} alt="checked icon" />} />
								}
								label={
									<div>
										<Typography className={classes.title}>
											{button.name}
										</Typography>
										<Typography className={classes.description}>
											{button.description}
										</Typography>
									</div>
								}
							/>
						)}
					</RadioGroup>
					{bottomHelperText ? (
						<FormHelperText
							id={`${rest.id}-helper-text`}
							className={classes.bottomHelperText}
							disabled={disabled}>{bottomHelperText}</FormHelperText>
					) : null}
				</div>
			) : (
				<LinearProgress className={classes.progress} />
			)}
		</div>
	);
}

LabeledRadioGroup.propTypes = {
	value: PropTypes.string,
	topHelperText: PropTypes.string,
	bottomHelperText: PropTypes.string,
	buttonColor: PropTypes.string,
	buttons: PropTypes.array.isRequired,
	onChange: PropTypes.func,
	isLoading: PropTypes.bool,
	disabled: PropTypes.bool,
	name: PropTypes.string
};

export default LabeledRadioGroup;
